var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { plainToClass } from 'class-transformer';
import { Clinic, Patient } from 'models';
import Model from 'models/Model';
import PatientJourneyStep from './PatientJourneyStep';
var PatientJourney = /** @class */ (function (_super) {
    __extends(PatientJourney, _super);
    function PatientJourney() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PatientJourney.prototype.getId = function () {
        return Number(this.id);
    };
    PatientJourney.prototype.getPatientId = function () {
        return Number(this.patient_id);
    };
    PatientJourney.prototype.setPatientId = function (patientId) {
        this.patient_id = patientId;
    };
    PatientJourney.prototype.getClinicId = function () {
        return Number(this.clinic_id);
    };
    PatientJourney.prototype.setClinicId = function (clinicId) {
        this.clinic_id = clinicId;
    };
    PatientJourney.prototype.getReceptionDeskId = function () {
        return this.reception_desk_id != null ? Number(this.reception_desk_id) : undefined;
    };
    PatientJourney.prototype.setReceptionDeskId = function (receptionDeskId) {
        this.reception_desk_id = receptionDeskId;
    };
    PatientJourney.prototype.getNotes = function () {
        return this.notes || '';
    };
    PatientJourney.prototype.setNotes = function (notes) {
        this.notes = notes;
    };
    PatientJourney.prototype.getCurrentState = function () {
        return this.current_state || 'open';
    };
    PatientJourney.prototype.getDisplayedState = function () {
        var state = this.getCurrentState();
        return state === 'abandoned' ? 'cancelled' : state;
    };
    PatientJourney.prototype.getPatient = function () {
        return this.patient ? plainToClass(Patient, this.patient) : undefined;
    };
    PatientJourney.prototype.getPatientName = function () {
        var _a;
        return ((_a = this.getPatient()) === null || _a === void 0 ? void 0 : _a.getName()) || String(this.getPatientId() || '—');
    };
    PatientJourney.prototype.getClinic = function () {
        return this.clinic ? plainToClass(Clinic, this.clinic) : undefined;
    };
    PatientJourney.prototype.getClinicName = function () {
        var _a;
        return ((_a = this.getClinic()) === null || _a === void 0 ? void 0 : _a.getName()) || String(this.getClinicId() || '—');
    };
    PatientJourney.prototype.getReceptionDeskName = function () {
        var _a;
        return ((_a = this.reception_desk) === null || _a === void 0 ? void 0 : _a.name) || '';
    };
    PatientJourney.prototype.getFacilityLabel = function () {
        var _a, _b;
        var clinic = ((_b = (_a = this.getClinic()) === null || _a === void 0 ? void 0 : _a.getName) === null || _b === void 0 ? void 0 : _b.call(_a)) || '';
        var desk = this.getReceptionDeskName();
        if (clinic && desk)
            return "".concat(clinic, " - ").concat(desk);
        return clinic || desk || '';
    };
    PatientJourney.prototype.getSteps = function () {
        return plainToClass(PatientJourneyStep, (this.patient_journey_steps || [])).sort(function (a, b) { return a.getPosition() - b.getPosition(); });
    };
    PatientJourney.prototype.isTerminal = function () {
        return ['completed', 'cancelled', 'abandoned'].includes(this.getCurrentState());
    };
    return PatientJourney;
}(Model));
export default PatientJourney;
